import { createMutation } from "react-query-kit";
import type { MutationFunction } from "@tanstack/react-query";

import { axiosClient, queryClient } from "../../clients";

import type { IMemberResearchProjects } from "./routeType";

import type { IPickMutation } from "@/api";
import { getApi } from "@api/apiPath";
import { useGetAllMemberResearchProjects } from "@/api/members/researchProjects/getAll";
import { useGetMemberResearchProject } from "@/api/members/researchProjects/get";

const { getPath } = getApi("members.researchProject.put");

type IExtractedRouteType =
  IMemberResearchProjects["researchProjectSingleUpdate"];

export type IPutMemberResearchProject = IPickMutation<IExtractedRouteType>;

const putMemberResearchProject: MutationFunction<
  IPutMemberResearchProject["response"],
  IPutMemberResearchProject["variables"]
> = ({ memberId, projectId, ...data }) => {
  return axiosClient.put(getPath({ memberId, projectId }), data);
};

export const usePutMemberResearchProject = createMutation({
  mutationFn: putMemberResearchProject,
  onSuccess: (_, { memberId }) => {
    queryClient.invalidateQueries({
      queryKey: useGetAllMemberResearchProjects.getKey(),
    });
    queryClient.invalidateQueries({
      queryKey: useGetMemberResearchProject.getKey({ memberId }),
    });
  },
});
